import { State as ContactsState } from '~/context/UserEnvironmentContext/chat/contactsReducer';
import { State as ChatContactsState } from '~/context/UserEnvironmentContext/chat/chatContactsReducer';

export function selectUnreadMessageCount(chatContacts: ChatContactsState, contacts: ContactsState): number {
  return chatContacts.data
    .reduce<number>((previousValue, currentValue) => previousValue + contacts[currentValue]?.data?.unread ?? 0, 0);
}